<div data-testid="assign-store-dialog-container" class="assign-store-dialog p-4">
  <div class="space-y-4">
    <div class="field">
      <label for="asd-business-unit" class="block text-sm font-medium mb-2">
        {{ "configuration.business_unit.dialog.business_unit" | translate }}
      </label>
      <app-paginated-select
        data-testid="assign-store-dialog-business-unit-select"
        inputId="asd-business-unit"
        [(ngModel)]="selectedBusinessUnitId"
        [paginatedOptions]="businessUnitPaginatedConfig"
        [placeholder]="
          'configuration.business_unit.dialog.select_business_unit' | translate
        "
        [showClear]="true"
        panelStyleClass="assign-store-select-panel"
      ></app-paginated-select>
    </div>

    <div class="field">
      <label for="asd-stores" class="block text-sm font-medium mb-2">
        {{ "configuration.business_unit.dialog.stores" | translate }}
      </label>
      <app-paginated-select
        data-testid="assign-store-dialog-stores-select"
        inputId="asd-stores"
        [(ngModel)]="selectedStoreIds"
        [paginatedOptions]="storePaginatedConfig"
        [multiple]="true"
        [placeholder]="
          'configuration.business_unit.dialog.select_stores' | translate
        "
        [showClear]="true"
        scrollHeight="250px"
        panelStyleClass="assign-store-multiselect-panel"
      ></app-paginated-select>
    </div>

    <div class="flex justify-end gap-3 pt-4 border-t border-gray-200">
      <app-button
        [testId]="'assign-store-dialog-cancel-btn'"
        [label]="'common.actions.cancel' | translate"
        type="secondary"
        [outlined]="true"
        [disabled]="loading"
        (emitOnClick)="onCancel()"
      ></app-button>
      <app-button
        [testId]="'assign-store-dialog-save-btn'"
        [label]="'common.actions.save' | translate"
        type="info"
        [disabled]="!isValid || loading"
        [loading]="loading"
        (emitOnClick)="onSave()"
      ></app-button>
    </div>
  </div>
</div>
